// @flow
import { styled } from 'mz-ui-kit'

export const Container = styled('div', {
  position: 'relative',
  display: 'flex',
  flexFlow: 'column nowrap',
  minWidth: '250px',
  height: '100%',
})

export const OptionsLoadingWrapper = styled<{ $loading?: boolean }>(
  'div',
  ({ $loading }) => ({
    opacity: $loading ? 0.4 : 1,
    pointerEvents: $loading ? 'none' : 'inherit',
    transition: 'all 430ms cubic-bezier(0.165, 0.84, 0.44, 1)',
    display: 'flex',
    flexGrow: 1,
  })
)

export const OptionWrapper = styled<{}>('div', ({ $palette }) => ({
  userSelect: 'none',
  position: 'relative',
  padding: '10px',
  ':active': {
    backgroundColor: `${$palette('primary')} !important`,
    color: `${$palette('white')}`,
  },
}))

export const InputContainer = styled('div', {
  flexGrow: 1,
  minWidth: 0,
})

export const PlaceholderTitle = styled('h3', {
  fontSize: '18px',
  fontWeight: 'normal',
  margin: 0,
  paddingRight: '45px',
})

export const FieldContainer = styled('div', {
  padding: '25px 10px 10px 10px',
})
